import { montserratBold, montserratNormal, montserratSemibold } from '@/assets/fonts/montserrat'
import React, { useEffect, useState } from 'react'
import Image from "next/image"
import first from "@/assets/reconciliation-automate/study-case/fnb/1.png"
import second from "@/assets/reconciliation-automate/study-case/fnb/2.png"
import third from "@/assets/reconciliation-automate/study-case/fnb/3.png"
import fourth from "@/assets/reconciliation-automate/study-case/fnb/4.png"
import fifth from "@/assets/reconciliation-automate/study-case/fnb/5.png"
import main from "@/assets/reconciliation-automate/study-case/fnb/main.png"
import firstRetail from "@/assets/reconciliation-automate/study-case/retail/1.png"
import secondRetail from "@/assets/reconciliation-automate/study-case/retail/2.png"
import thirdRetail from "@/assets/reconciliation-automate/study-case/retail/3.png"
import mainRetail from "@/assets/reconciliation-automate/study-case/retail/mainRetail.png"
import img1 from "@/assets/reconciliation-automate/study-case/1.png"
import img2 from "@/assets/reconciliation-automate/study-case/2.png"
import img1Mobile from "@/assets/reconciliation-automate/study-case/1-mobile.png"
import img2Mobile from "@/assets/reconciliation-automate/study-case/2-mobile.png"

import { BanknotesIcon, DocumentTextIcon } from '@heroicons/react/24/solid'
import { motion } from "framer-motion"
import { CheckCircleIcon } from '@heroicons/react/24/outline'
import { t } from 'i18next'

export default function StudyCase() {

  const [indexChoosed, setindexChoosed] = useState(0)
  const [progressInterval, setprogressInterval] = useState(0)
  const [changeIndex, setchangeIndex] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
      // Increment progress by 20% every second until it reaches 100%
      setprogressInterval(prev => prev + 100)
    },1000);
  
    return () => clearInterval(interval);
  }, [])

  useEffect(() => {
    console.log("Progress ", progressInterval)
    if (progressInterval >= 700) {
      setindexChoosed(prev => prev >= 1 ? 0 : prev+1)
      setprogressInterval(0)
    }
  }, [progressInterval])
  
  const handleChange = (index) => {
    setprogressInterval(0)
    setindexChoosed(index)
  }

  useEffect(() => {
    console.log("Index choosed study", indexChoosed)
  }, [indexChoosed])
  

  return (
    <div className='flex flex-col lg:px-8 py-16 lg:container max-w-[1280px] lg:mx-auto w-full h-full'>
      <div className='flex flex-col w-full justify-center items-center lg:justify-start lg:items-start lg:w-1/2'>
        <p className={`${montserratSemibold.className} flex justify-center items-center lg:text-left lg:items-start lg:justify-start text-blue-primary-500`}>
          {t('recon_study_case_tiny_title')}
        </p>
        <h1 className={`${montserratBold.className} flex justify-center items-center lg:justify-start text-center lg:text-left text-gray-cool-700 text-[36px] pt-3 pb-8 leading-[43px]`}>
          {t('recon_study_case_title')}
        </h1>
      </div>
      <div className='w-full h-full px-4 lg:px-0 gap-6 grid grid-cols-1 lg:grid-cols-2'>
        <div className='w-full flex flex-col h-full p-4 md:p-8 row-span-2 rounded-[8px] border-[1px] border-gray-cool-200 overflow-hidden'>
          <div className='flex flex-col w-full'>
            <div className={`${montserratSemibold.className} text-gray-cool-700 text-[24px] flex`}>
              {t('recon_study_case_list_title')}
              <div className={`ml-3 px-[10px] w-fit py-[2px] rounded-md bg-blue-primary-50 flex justify-center items-center ${montserratSemibold.className} text-gray-cool-700`}>
                {
                  indexChoosed == 0 && (
                    <motion.p 
                    initial={{opacity:0}}
                    animate={{opacity: indexChoosed == 0 ? 1 : 0, transition: {ease: "easeInOut", duration: 1}}}
                    >{t('recon_study_case_list_item_fnb')}</motion.p>
                  )
                }
                {
                  indexChoosed == 1 && (
                    <motion.p 
                    initial={{opacity:0}}
                    animate={{opacity: indexChoosed == 0 ? 0 : 1,transition: {ease: "easeInOut", duration: 0.5}}}
                    >{t('recon_study_case_list_item_retail')}</motion.p>
                  )
                }
              </div>
            </div>
            {
              indexChoosed == 0 && (
              <p className={`pt-2 pb-8 ${montserratNormal.className} text-[20px] text-gray-cool-500`}>
                {t('recon_study_case_list_item_description_fnb')}
              </p>
              )
            }
            {
              indexChoosed == 1 && (
              <p className={`pt-2 pb-8 ${montserratNormal.className} text-[20px] text-gray-cool-500`}>
                {t('recon_study_case_list_item_description_retail')}
              </p>
              )
            }
            <div className='flex-col flex w-full'>
              <div className={`${montserratSemibold.className} text-gray-cool-700 text-[24px] pb-3 flex`}>{t('recon_study_case_client_title')}</div>
              <div className={`border-t-[2px] border-b-[2px] border-gray-cool-200 w-full flex flex-wrap py-3`}>
                {
                  indexChoosed == 1 && (
                    <>
                      <motion.div 
                        initial={{opacity: 0}}
                        animate={{
                          opacity: indexChoosed != 0 ? 1 : 0, 
                          filter: "blur(0px)",
                          transition:{ ease: "easeInOut", duration: 1.2 } 
                        }}
                        className={`${indexChoosed == 1 ? "relative" : "absolute"} flex w-[4rem] md:w-[6rem] h-fit bg-contain object-contain`}
                      >
                        <Image src={firstRetail}/>
                      </motion.div>
                      <motion.div 
                        initial={{opacity: 0}}
                        animate={{
                          opacity: indexChoosed != 0 ? 1 : 0, 
                          filter: "blur(0px)",
                          scale: 1,
                          transition:{ ease: "easeInOut", duration: 1.2 } }} 
                        className={`${indexChoosed == 1 ? "relative" : "absolute"} flex w-[2.7rem] ml-6 md:w-[4.5rem] h-fit bg-contain object-contain`}>
                        <Image src={secondRetail}/>
                      </motion.div>
                      <motion.div
                         initial={{opacity: 0}}
                         animate={{
                           opacity: indexChoosed != 0 ? 1 : 0, 
                           filter: "blur(0px)",
                           transition:{ ease: "easeInOut", duration: 1.2 } }} 
                        className={`${indexChoosed == 1 ? "relative" : "absolute"} flex w-[4rem] ml-6 md:w-[6rem] h-fit bg-contain object-contain`}>
                        <Image src={thirdRetail}/>
                      </motion.div>
                    </>
                  )
                }
                {
                  indexChoosed == 0 && (
                    <>
                      <motion.div 
                        initial={{opacity: 0, filter: "blur(0px)"}}
                        animate={{opacity: indexChoosed != 0 ? 0 : 1, transition:{ ease: "easeInOut", duration: 1 } }}
                        className={`${indexChoosed == 0 ? "relative" : "absolute"} flex w-[4rem] md:w-[6rem] h-fit bg-contain object-contain`}
                      >
                        <Image src={first}/>
                      </motion.div>
                      <motion.div 
                        initial={{opacity: 0, filter: "blur(0px)"}}
                        animate={{opacity: indexChoosed != 0 ? 0 : 1, transition:{ ease: "easeInOut", duration: 1 } }} 
                        className={`${indexChoosed == 0 ? "relative" : "absolute"} flex w-[3.3rem] ml-6 md:w-[5.7rem] h-fit bg-contain object-contain `}>
                        <Image src={second}/>
                      </motion.div>
                      <motion.div
                        initial={{opacity: 0, filter: "blur(0px)"}}
                        animate={{opacity: indexChoosed != 0 ? 0 : 1, transition:{ ease: "easeInOut", duration: 1 } }} 
                        className={`${indexChoosed == 0 ? "relative" : "absolute"} flex w-[2rem] ml-6 md:w-[3.7rem] h-fit bg-contain object-contain`}>
                        <Image src={third}/>
                      </motion.div>
                      <motion.div 
                        initial={{opacity: 0, filter: "blur(0px)"}}
                        animate={{opacity: indexChoosed != 0 ? 0 : 1, transition:{ ease: "easeInOut", duration: 1 } }} 
                        className={`${indexChoosed == 0 ? "relative" : "absolute"} flex w-[4rem] ml-6 md:w-[6rem] h-fit bg-contain object-contain`}>
                        <Image src={fourth}/>
                      </motion.div>
                      <motion.div 
                          initial={{opacity: 0, filter: "blur(0px)"}}
                          animate={{
                            opacity: indexChoosed != 0 ? 0 : 1, 
                            transition:{ ease: "easeInOut", duration: 1 } 
                          }} 
                          className={`${indexChoosed == 0 ? "relative" : "absolute"} w-[3.5rem] ml-6 mt-3 md:mt-0 md:ml-6 md:flex md:w-[4.5rem] h-fit bg-contain object-contain`}>
                        <Image src={fifth}/>
                      </motion.div>
                    </>
                  )
                }
              </div>
              <div className='py-8 w-full flex justify-end'>
                <div onClick={() => handleChange(0)} className={`${indexChoosed == 0 ? "w-[48px] bg-blue-primary-500 h-[12px]" : "w-[12px] bg-gray-cool-200 h-[12px]"} mr-[8px] hover:cursor-pointer rounded-full`}></div>
                <div onClick={() => handleChange(1)} className={`rounded-full hover:cursor-pointer ${indexChoosed != 0 ? "w-[48px] bg-blue-primary-500 h-[12px]" : "w-[12px] bg-gray-cool-200 h-[12px]"}`}></div>
              </div>
            </div>
            <div className='pt-8 w-full h-full relative flex'>
              {
                indexChoosed == 0 && (
                  <motion.div 
                    // initial={{opacity: 0, filter: "blur(0px)"}}
                    // animate={{opacity: indexChoosed != 0 ? 0 : 1, transition:{ ease: "easeInOut", duration: 1 } }} 
                    className='flex'>
                      <Image src={main} />
                  </motion.div>
                )
              }
              {
                indexChoosed == 1 && (
                  <motion.div 
                    // initial={{opacity: 0, filter: "blur(0px)"}}
                    // animate={{opacity: indexChoosed != 0 ? 1 : 0, transition:{ ease: "easeInOut", duration: 1 } }} 
                    className='flex'>
                      <Image src={mainRetail} />
                  </motion.div>
                )
              }
              
              {
                indexChoosed == 0 && (
                  <motion.div 
                    initial={{opacity: 1, filter:"blur(0px)",}}
                    animate={{opacity: indexChoosed == 0 ? 1 : 0, transition:{ease : "easeOut",duration:1}}}
                    className={`flex absolute z-20 top-12 left-3 md:left-10 md:-top-1`}>
                    <div className='hidden md:flex left-2 border border-gray-cool-200 rounded-[8px] w-[90%] px-4 py-3 absolute z-10 -top-4 bg-base-white' />
                    <div className='flex left-1 border border-gray-cool-200 rounded-[8px] w-[95%] px-4 py-3 absolute z-10 -top-2 bg-base-white' />
                    <div className='flex drop-shadow-md p-2 overflow-hidden flex-col space-y-[2px] border border-gray-cool-200 py-2 px-[10px] rounded-[8px] md:w-[224px] lg:w-[100%] md:px-4 md:py-3 lg:px-4 lg:py-3 relative z-20 bg-base-white'>
                      <div className='flex pb-[2px] items-center'>
                        <div className='text-gray-cool-500 w-[8px] md:w-[12px]'>
                          <DocumentTextIcon />
                        </div>
                        <p className={`pl-[6px] text-[8px] md:text-xs ${montserratNormal.className} text-gray-cool-500`}>Online Sales</p>
                      </div>
                      <div
                        className='flex items-center'>
                        <div className={`text-gray-cool-500 text-[8px] md:text-xs ${montserratNormal.className}`}>
                          Rp
                        </div>
                        <p className={`pl-[6px] text-[10px] md:text-base ${montserratSemibold.className} text-gray-cool-700`}>145,213,395.76</p>
                      </div>
                    </div>
                </motion.div>
                )
              }
              {
                indexChoosed == 1 && (
                  <div 
                    className={`flex absolute flex-col left-2 top-10 md:left-10 md:-top-1`}>
                    <div
                      className='flex drop-shadow-md p-2 overflow-hidden flex-col space-y-[2px] border border-gray-cool-200 py-2 px-[10px] rounded-[8px] md:w-[224px] lg:w-[100%] md:px-4 md:py-3 lg:px-4 lg:py-3 relative z-20 bg-base-white'>
                      <div className='flex pb-[2px] items-center'>
                        <div className='text-gray-cool-500 w-[8px] md:w-[12px]'>
                          <DocumentTextIcon />
                        </div>
                        <p className={`pl-[2px] md:pl-[6px] text-[8px] md:text-xs ${montserratNormal.className} text-gray-cool-500`}>Sales Report</p>
                      </div>
                      <div
                        className='flex items-center'>
                        <div className={`text-gray-cool-500 text-[8px] md:text-xs ${montserratNormal.className}`}>
                          Rp
                        </div>
                        <p className={`pl-[2px] md:pl-[6px] text-[10px] md:text-base ${montserratSemibold.className} text-gray-cool-700`}>145,213,395.76</p>
                      </div>
                    </div>
                    <motion.div 
                      initial={{y: -100,opacity: 1, filter:"blur(0px)",}}
                      animate={{y: 0,opacity: indexChoosed == 0 ? 0 : 1, transition:{ease : "easeOut",duration:1}}}
                      className='flex my-2 md:my-5 drop-shadow-md p-2 overflow-hidden flex-col space-y-[2px] border border-gray-cool-200 py-2 px-[10px] w-fit rounded-[8px] md:w-[224px] lg:w-[100%] md:px-4 md:py-3 lg:px-4 lg:py-3 relative z-20 bg-base-white'>
                      <div className='flex pb-[2px] items-center'>
                        <div className='text-gray-cool-500 w-[8px] md:w-[12px]'>
                          <BanknotesIcon />
                        </div>
                        <p className={`pl-[2px] md:pl-[6px] text-[8px] md:text-xs ${montserratNormal.className} text-gray-cool-500`}>Bank</p>
                      </div>
                      <div
                        className='flex items-center'>
                        <div className={`text-gray-cool-500 text-[8px] md:text-xs ${montserratNormal.className}`}>
                          Rp
                        </div>
                        <p className={`pl-[2px] md:pl-[6px] text-[10px] md:text-base ${montserratSemibold.className} text-gray-cool-700`}>143,761,261.80</p>
                      </div>
                    </motion.div>
                </div>
                )
              }
              {
                indexChoosed == 0 && (
                  <motion.div 
                    initial={{y:-80, opacity: 1, filter:"blur(0px)",}}
                    animate={{y: indexChoosed == 1 ? -100 : 0, opacity: indexChoosed == 0 ? 1 : 0, transition:{ease : "easeOut",duration:0.5}}} 
                    className={`flex absolute left-3 top-28 md:left-10 md:top-20 px-3 py-[6px] justify-center items-center rounded-full bg-base-white border-[1px] border-blue-primary-500`}>
                    <p className={`${montserratNormal.className} text-[8px] md:text-xs pr-1 text-blue-primary-500`}>Payment Channel</p>
                    <p className={`${montserratSemibold.className} text-[8px] md:text-xs pr-1 text-blue-primary-500`}>1%</p>
                  </motion.div>
                )
              }
              {
                indexChoosed == 1 && (
                  <motion.div 
                    initial={{y:-150, opacity: 0, filter:"blur(0px)",}}
                    animate={{y: indexChoosed == 1 ? 0 : 0, opacity: indexChoosed == 0 ? 0 : 1, transition:{ease : "easeOut",duration:1, delay: 0.2}}} 
                    className={`flex absolute left-2 top-[156px] md:left-10 md:top-44 px-3 py-[6px] justify-between w-[107px] md:w-[155px] items-center rounded-full bg-base-white border-[1px] border-semantic-positive-500`}>
                    <p className={`${montserratNormal.className} text-[8px] md:text-xs pr-1 text-semantic-positive-500`}>Match!</p>
                    <p className={`${montserratSemibold.className} text-[8px] md:text-xs pr-1 text-semantic-positive-500`}>Admin 1%</p>
                  </motion.div>
                )
              }
              
            </div>
          </div>
        </div>
        <div className='rounded-[8px] border-[1px] h-fit border-gray-cool-200 overflow-hidden flex md:flex-row flex-col justify-between'>
          <div className='flex w-full flex-col px-4 py-4 md:pl-8 md:py-8'>
              <p className={`${montserratSemibold.className} text-[24px] text-gray-cool-700`}>
                Business Owner
              </p>
              <div className='w-[70px] my-4 bg-blue-primary-500 rounded-full h-[2px]'/>
              <ul className='block space-y-4 md:max-w-[298px] relative w-full h-full'>
                <li className='w-full relative flex'>
                  <CheckCircleIcon className='text-blue-primary-500 absolute top-1 w-4' />
                  <p className={`${montserratNormal.className} relative left-5 flex flex-wrap w-full pr-4 md:pr-0 text-gray-cool-500`}>
                    {t('recon_study_case_business_owner_text_1')}
                  </p>
                </li>
                <li className='w-full relative flex'>
                  <CheckCircleIcon className='text-blue-primary-500 absolute top-1 w-4' />
                  <p className={`${montserratNormal.className} relative left-5 flex flex-wrap w-full pr-4 md:pr-0 text-gray-cool-500`}>
                    {t('recon_study_case_business_owner_text_2')}
                  </p>
                </li>
                <li className='w-full relative flex'>
                  <CheckCircleIcon className='text-blue-primary-500 absolute top-1 w-4' />
                  <p className={`${montserratNormal.className} relative left-5 flex flex-wrap w-full pr-4 md:pr-0 text-gray-cool-500`}>
                    {t('recon_study_case_business_owner_text_3')}
                  </p>
                </li>
              </ul>
          </div>
          <div className='hidden md:flex pl-[48px] md:w-[30rem] lg:w-[40rem] h-fit justify-end'>
              <Image src={img1} alt="TEst" />
          </div>
          <div className='flex md:hidden lg:w-[40rem] h-fit justify-end'>
              <Image src={img1Mobile} alt="TEst" />
          </div>
        </div>
        <div className='rounded-[8px] border-[1px] h-fit border-gray-cool-200 overflow-hidden flex md:flex-row flex-col justify-between'>
          <div className='flex w-full flex-col px-4 py-4 md:pl-8 md:py-8'>
              <p className={`${montserratSemibold.className} text-[24px] text-gray-cool-700`}>
                Finance Team
              </p>
              <div className='w-[70px] my-4 bg-blue-primary-500 rounded-full h-[2px]'/>
              <ul className='block space-y-4 md:max-w-[298px] relative w-full h-full'>
                <li className='w-full relative flex'>
                  <CheckCircleIcon className='text-blue-primary-500 absolute top-1 w-4' />
                  <p className={`${montserratNormal.className} relative flex flex-wrap w-full left-5 pr-4 md:pr-0 text-gray-cool-500`}>
                    {t('recon_study_case_finance_team_text_1')}
                  </p>
                </li>
                <li className='w-full relative flex'>
                  <CheckCircleIcon className='text-blue-primary-500 absolute top-1 w-4' />
                  <p className={`${montserratNormal.className} relative flex flex-wrap w-full left-5 pr-4 md:pr-0 text-gray-cool-500`}>
                    {t('recon_study_case_finance_team_text_2')}
                  </p>
                </li>
                <li className='w-full relative flex'>
                  <CheckCircleIcon className='text-blue-primary-500 absolute top-1 w-4' />
                  <p className={`${montserratNormal.className} relative flex flex-wrap w-full left-5 pr-4 md:pr-0 text-gray-cool-500`}>
                    {t('recon_study_case_finance_team_text_3')}
                  </p>
                </li>
              </ul>
          </div>
          <div className='hidden md:flex pl-[48px] md:w-[30rem] lg:w-[40rem] h-fit justify-end'>
              <Image src={img2} alt="TEst" />
          </div>
          <div className='flex md:hidden  lg:w-[40rem] h-fit justify-end'>
              <Image src={img2Mobile} alt="TEst" />
          </div>
        </div>
      </div>
    </div>
  )
}
